import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

var Routes = [
    {
        name: "login",
        path: "/login",
        component: () => import('../components/Login'),
        meta: { middleware: "guest", title: `Авторизация` }
    },
    {
        path: "/",
        name: "base",
        component: () => import('../components/Layouts/Base'),
        meta: { middleware:"auth" },
        children: [
            {
                name: "root",
                path: '/root/',
                component: () => import('../components/Pages/Root/Root'),
                meta: { title: `Супер пользователь` },
                children: [
                    {
                        name: "root_hotel_chain",
                        path: '/root/hotel-chain/',
                        component: () => import('../components/Pages/Root/Pages/Chains'),
                        meta:{ title: `Сети` },
                    },
                    {
                        name: "root_hotels",
                        path: '/root/hotels/',
                        component: () => import('../components/Pages/Root/Pages/Hotels'),
                        meta: { title: `Отели` },
                    },
                    {
                        name: "root_builds",
                        path: '/root/builds/',
                        component: () => import('../components/Pages/Root/Pages/Builds'),
                        meta: { title: `Корпуса` },
                    },
                    {
                        name: "root_rooms",
                        path: '/root/rooms/',
                        component: () => import('../components/Pages/Root/Pages/Rooms'),
                        meta: { title: `Номера` },
                    },
                    {
                        name: "root_room_types",
                        path: '/root/room-types/',
                        component: () => import('../components/Pages/Root/Pages/RoomTypes'),
                        meta: { title: `Типы номеров` },
                    },
                    {
                        name: "root_floors",
                        path: '/root/floors/',
                        component: () => import('../components/Pages/Root/Pages/Floors'),
                        meta: { title: `Этажи` },
                    },
                    {
                        name: "root_users",
                        path: '/root/users/',
                        component: () => import('../components/Pages/Root/Pages/Users'),
                        meta: { title: `Пользователи` },
                    },
                    {
                        name: "root_executor_costs",
                        path: '/root/executor-costs/',
                        component: () => import('../components/Pages/Root/Pages/ExecutorCosts'),
                        meta: { title: `Стоимость смены` },
                    },
                    {
                        name: "root_spa_salons",
                        path: '/root/spa-salons/',
                        component: () => import('../components/Pages/Root/Pages/SpaSalons'),
                        meta: { title: `Спа-салоны` },
                    },
                    {
                        name: "root_beauty_salons",
                        path: '/root/beauty-salons/',
                        component: () => import('../components/Pages/Root/Pages/BeautySalons'),
                        meta: { title: `Салоны красоты` },
                    },
                    {
                        name: "root_staff_list_works",
                        path: '/root/staff-list-works/',
                        component: () => import('../components/Pages/Root/Pages/StaffListWorks'),
                        meta: { title:`Управление видами работ` },
                    },
                    {
                        name: "root_currencies",
                        path: '/root/currencies/',
                        component: () => import('../components/Pages/Root/Pages/Currencies'),
                        meta: { title: `Валюты` },
                    },
                    {
                        name: "check_lists",
                        path: '/root/check-lists/',
                        component: () => import('../components/Pages/Root/Pages/CheckLists'),
                        meta: { title: `Чек-листы` },
                    },
                    {
                        name: "work_types",
                        path: '/root/work-types/',
                        component: () => import('../components/Pages/Root/Pages/WorkTypes'),
                        meta: { title: `Типы работ` },
                    },
                    {
                        name: "root_add_works",
                        path: '/root/add-works/',
                        component: () => import('../components/Pages/Root/Pages/AddWorks'),
                        meta: { title: `Доп. работы` },
                    },
                    {
                        name: "max_wage_reduction",
                        path: '/root/max-wage-reduction/',
                        component: () => import('../components/Pages/Root/Pages/MaxWageReduction'),
                        meta: { title: `Максимальный % снижения ЗП` },
                    },
                ]
            },
            {
                name: "director",
                path: '/director/',
                component: () => import('../components/Pages/Director/Director'),
                meta: { title: `Роль: Директор` },
                children: [
                    {
                        name: "director_users",
                        path: '/director/users/',
                        component: () => import('../components/Pages/Director/Pages/Users'),
                        meta: { title: `Управление пользователями` },
                    },
                    {
                        name: "director_users_logs",
                        path: '/director/users/logs',
                        component: () => import('../components/Pages/Director/Pages/UserLogs'),
                        meta: { title: `Логирование действий пользователей` },
                    }
                ]
            },
            {
                name: "manager",
                path: '/manager/',
                component: () => import('../components/Pages/Manager/Manager.vue'),
                meta: { title: `Роль: Управляющий` },
                children:[
                    {
                        name: "manager_users",
                        path: '/manager/users/',
                        component: () => import('../components/Pages/Manager/Pages/Users'),
                        meta: { title: `Задачи на сегодня` },
                    },
                    {
                        name: "manager_users_logs",
                        path: '/manager/users/logs',
                        component: () => import('../components/Pages/Manager/Pages/UserLogs'),
                        meta: { title: `Логирование действий пользователей` },
                    },
                    {
                        name: "manager_menu",
                        path: '/manager/menu/',
                        component: () => import('../components/Pages/Manager/Pages/Menu'),
                        meta: { title: `Редактирование меню` },
                    },
                    {
                        name: "manager_categories",
                        path: '/manager/categories/',
                        component: () => import('../components/Pages/Manager/Pages/Categories'),
                        meta: { title: `Редактирование категорий` },
                    },
                    {
                        name: "manager_clients",
                        path: '/manager/clients/',
                        component: () => import('../components/Pages/Manager/Pages/Clients'),
                        meta: { title:`Управление клиентами отеля` },
                    },
                    {
                        name: "manager_client",
                        path: '/manager/client/:id',
                        component: () => import('../components/Pages/Manager/Pages/Client'),
                        meta: { title:`Данные клиента` },
                    },
                    {
                        name: "Manager_recreation_types",
                        path: '/manager/recreation-types',
                        component: () => import('../components/Pages/Manager/Pages/RecreationTypes'),
                        meta: { title:`Виды отдыха` },
                    },
                    {
                        name: "manager_settings",
                        path: '/manager/settings/',
                        component: () => import('../components/Pages/Manager/Pages/Settings'),
                        meta: { title:`Настройки` },
                    },
                    {
                        name: "manager_order_report",
                        path: '/manager/order-report/',
                        component: () => import('../components/Pages/Manager/Pages/OrderReport'),
                        meta: { title: `Отчет по заказам` },
                    },
                    {
                        name: "manager_free_services",
                        path: '/manager/free-services/',
                        component: () => import('../components/Pages/Manager/Pages/FreeServices'),
                        meta: { title: `Беспл. услуги` },
                    },
                    {
                        name: "manager_paid_services",
                        path: '/manager/paid-services/',
                        component: () => import('../components/Pages/Manager/Pages/PaidServices'),
                        meta: { title: `Платные услуги` },
                    },
                    {
                        name: "manager_service_report",
                        path: '/manager/service-report/',
                        component: () => import('../components/Pages/Manager/Pages/ServiceReport'),
                        meta: { title: `Отчет по услугам` },
                    },
                    {
                        name:"manager_events",
                        path: '/manager/events/',
                        component: () => import('../components/Pages/Manager/Pages/Events'),
                        meta:{
                            title: `Мероприятия`
                        },
                    },
                    {
                        name:"manager_work_types",
                        path: '/manager/work_types/',
                        component: () => import('../components/Pages/Manager/Pages/WorkType'),
                        meta:{
                            title: `Типы работ`
                        },
                    },
                    {
                        name:"add_works",
                        path: '/manager/add-works/',
                        component: () => import('../components/Pages/Manager/Pages/AddWorks'),
                        meta:{
                            title: `Дополнительные работы`
                        },
                    },
                    {
                        name:"manager_reports",
                        path: '/manager/reports/',
                        component: () => import('../components/Pages/Manager/Pages/Reports'),
                        meta:{
                            title: `Отчеты`
                        },
                    },
                ]
            },
            {
                name: "administrator",
                path: '/administrator/',
                component: () => import('../components/Pages/Administrator/Administrator'),
                meta: { title: `Роль: Администратор` },
                children:[
                    {
                        name: "administrator_users",
                        path: '/administrator/users/',
                        component: () => import('../components/Pages/Administrator/Pages/Users'),
                        meta: { title: `Управление пользователями` },
                    },
                    {
                        name: "administrator_service_orders",
                        path: '/administrator/service-orders/',
                        component: () => import('../components/Pages/Administrator/Pages/ServiceOrder'),
                        meta: { title: `Управление заказами` },
                    },
                    {
                        name: "administrator_work_types",
                        path: '/administrator/admin-work-types/',
                        component: () => import('../components/Pages/Administrator/Pages/WorkTypes'),
                        meta: { title: `Типы работ` },
                    },
                    {
                        name: "administrator_tasks",
                        path: '/administrator/tasks/',
                        component: () => import('../components/Pages/Administrator/Pages/Tasks'),
                        meta: { title: `Задачи` },
                    },
                    {
                        name: "administrator_reports",
                        path: '/administrator/reports/',
                        component: () => import('../components/Pages/Administrator/Pages/Reports'),
                        meta: { title: `Отчеты` },
                    },
                    {
                        name: "administrator_profile",
                        path: '/administrator/profile',
                        component: () => import('../components/Pages/Administrator/Pages/Profile'),
                        meta: { title: `Профиль` },
                    },
                    {
                        name:"administrator_event_orders",
                        path: '/administrator/event-orders/',
                        component: () => import('../components/Pages/Administrator/Pages/EventOrder'),
                        meta:{
                            title:`Управление заказами мероприятий`
                        },
                    },
                    {
                        name:"administrator_room_service_orders",
                        path: '/administrator/room-service-orders/',
                        component: () => import('../components/Pages/Administrator/Pages/RoomServiceOrder'),
                        meta:{
                            title:`Управление заказами мероприятий`
                        },
                    },
                ]
            },
            {
                name: "senior_staff",
                path: '/senior-staff/',
                component: () => import('../components/Pages/SeniorStaff/SeniorStaff'),
                meta: { title: `Роль: Старшая горничная` },
                children:[
                    {
                        name: "senior_staff_tasks",
                        path: '/senior-staff/tasks',
                        component: () => import('../components/Pages/SeniorStaff/Pages/Tasks'),
                        meta: { title: `Задачи` },
                    },
                    {
                        name: "senior_staff_profile",
                        path: '/senior-staff/profile',
                        component: () => import('../components/Pages/SeniorStaff/Pages/Profile'),
                        meta: { title: `Профиль` },
                    },
                ]
            },
            {
                name: "staff",
                path: '/staff/',
                component: () => import('../components/Pages/Staff/Staff'),
                meta: { title: `Роль: Горничная` },
                children: [
                    {
                        name: "staff_tasks",
                        path: '/staff/staffTasks/',
                        component: () => import('../components/Pages/Staff/Pages/Tasks'),
                        meta: { title: `Работы` },
                    },
                ]
            },
            {
                name: "senior_administrator",
                path: '/senior_administrator/',
                component: () => import('../components/Pages/Senior_administrator/Senior_administrator'),
                meta: { title: `Старший Администратор` },
                children:[
                    {
                        name: "senior_administrator_users",
                        path: '/senior_administrator/users/',
                        component: () => import('../components/Pages/Senior_administrator/Pages/Users'),
                        meta: { title: `Задачи на сегодня` },
                    },
                ]
            },
            {
                name: "waiter",
                path: '/waiter/',
                component: () => import('../components/Pages/Waiter/Waiter'),
                meta: { title: `Роль: Официант` },
                children: [
                    {
                        name: 'waiter_orders',
                        path: '/waiter/orders/',
                        component: () => import('../components/Pages/Waiter/Pages/Orders'),
                        meta: { title: `Управление заказами` },
                    }
                ]
            },
            {
                name: "Menu-manager",
                path: '/menu-manager/',
                component: () => import('../components/Pages/MenuManager/MenuManager'),
                meta: { title: `Роль: Управляющий меню` },
                children:[
                    {
                        name: "menu_manage_categories",
                        path: '/menu-manager/categories/',
                        component: () => import('../components/Pages/MenuManager/Pages/Categories'),
                        meta: { title: `Редактирование категорий` },
                    },
                    {
                        name: "menu_manage_menu",
                        path: '/menu-manager/menu/',
                        component: () => import('../components/Pages/MenuManager/Pages/Menu'),
                        meta: { title: `Редактирование категорий` },
                    },
                ]
            },
            {
                name: "excursion-manager",
                path: '/excursion-manager/',
                component: () => import('../components/Pages/ExcursionManager/ExcursionManager'),
                meta: { title: `Роль: менеджера экскурсий` },
                children:[
                    {
                        name: "excursion-manager_categories",
                        path: '/excursion-manager/categories/',
                        component: () => import('../components/Pages/ExcursionManager/Pages/Categories'),
                        meta: { title: `Категории экскурсий` },
                    },
                    {
                        name: "excursion-manager_list",
                        path: '/excursion-manager/list/',
                        component: () => import('../components/Pages/ExcursionManager/Pages/Excursion'),
                        meta: { title: `Управление экскурсиями` },
                    },
                    {
                        name: "excursion-manager_orders",
                        path: '/excursion-manager/orders/',
                        component: () => import('../components/Pages/ExcursionManager/Pages/ExcursionOrder'),
                        meta: { title: `Заказы экскурсий` },
                    },
                ]
            },
            {
                name: "spa-manager",
                path: '/spa-manager/',
                component: () => import('../components/Pages/SpaManager/SpaManager'),
                meta: { title: `Роль: менеджера спа` },
                children:[
                    {
                        name: "spa-manager_list",
                        path: '/spa-manager/list/',
                        component: () => import('../components/Pages/SpaManager/Pages/SpaServices'),
                        meta: { title: `Управление спа услугами` },
                    },
                    {
                        name: "spa-manager_orders",
                        path: '/spa-manager/orders/',
                        component: () => import('../components/Pages/SpaManager/Pages/SpaServiceOrders'),
                        meta: { title: `Заказы спа услуг` },
                    },
                ]
            },
            {
                name: "beauty-manager",
                path: '/beauty-manager/',
                component: () => import('../components/Pages/BeautyManager/BeautyManager'),
                meta: { title: `Роль: менеджера салонов красоты` },
                children:[
                    {
                        name: "beauty-manager_categories",
                        path: '/beauty-manager/categories/',
                        component: () => import('../components/Pages/BeautyManager/Pages/Categories'),
                        meta: { title: `Управление категориями` },
                    },
                    {
                        name: "beauty-manager_services",
                        path: '/beauty-manager/services/',
                        component: () => import('../components/Pages/BeautyManager/Pages/Services'),
                        meta: { title: `Управление услугами` },
                    },
                    {
                        name: "beauty-manager_orders",
                        path: '/beauty-manager/orders/',
                        component: () => import('../components/Pages/BeautyManager/Pages/BeautyOrder'),
                        meta: { title: `Заказы услуг салонов красоты` },
                    },
                ]
            },
            {
                name: "restaurant-manager",
                path: '/restaurant-manager/',
                component: () => import('../components/Pages/RestaurantManager/RestaurantManager'),
                meta:{
                    title:`Роль: менеджера ресторанов`
                },
                children:[
                    {
                        name:"restaurant-manager_categories",
                        path: '/restaurant-manager/categories/',
                        component: () => import('../components/Pages/RestaurantManager/Pages/Categories'),
                        meta:{
                            title: `Управление категориями ресторанов`
                        },
                    },
                    {
                        name:"restaurant-manager_restaurants",
                        path: '/restaurant-manager/restaurants/',
                        component: () => import('../components/Pages/RestaurantManager/Pages/Restaurants'),
                        meta:{
                            title: `Управление ресторанами`
                        },
                    },
                    {
                        name:"restaurant-manager_services",
                        path: '/restaurant-manager/services/',
                        component: () => import('../components/Pages/RestaurantManager/Pages/Services'),
                        meta:{
                            title: `Управление услугами ресторанов`
                        },
                    },
                    {
                        name:"restaurant-manager_orders",
                        path: '/restaurant-manager/orders/',
                        component: () => import('../components/Pages/RestaurantManager/Pages/RestaurantServiceOrders'),
                        meta:{
                            title: `Управление заказами ресторанов`
                        },
                    }
                ]
            },
        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../components/Error404'),
    },
    {
        path: '*',
        redirect: '/404'
    }
]

/**
 * Роли
 * 0 - root, api
 * 1 - Супер пользователь, 2 - Директор, 3 - Старший администратор, 4 - Администратор
 * 5 - Старшая горничная, 6 - Горничная
 * Планируемые: 7 - Хозяйственик, 8 - Прачка
 */


var router  = new VueRouter({
    mode: 'history',
    routes: Routes
})

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} - ${process.env.MIX_APP_NAME}`
    if(to.meta.middleware === "guest"){
        if(store.state.auth.authenticated){
            next({name:"base"})
        }
        else next()
    }else{
        if(store.state.auth.authenticated){
            next()
        } else {
            next({name: "login"})
        }
    }
})

export default router
